

















import Vue from 'vue'
import scooterIcon from '@/assets/icones/scooter.png'

export default Vue.extend({
	props: ["params"],
	data() {
		return { scooterIcon }
	},
	computed: {
		isPinnedTotal(this: any): boolean {
			return this.params?.node?.rowPinned === 'bottom' && this.params?.data?.isTotalRow === true
		},
		icone(this: any): string {
			if (this.params?.data?.isEntregaExpressa) return 'mdi-motorbike'
			return this.params?.data?.displayModalidadeDoFrete !== 'Retirada local' ? 'mdi-truck-check' : 'mdi-store'
		},
	},
})
